import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dot-base-booker-skeleton',
  templateUrl: './base-booker-skeleton.component.html',
  styleUrls: ['./base-booker-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseBookerSkeletonComponent {}
